import { render, staticRenderFns } from "./ConcessionaryDetails.vue?vue&type=template&id=6db4843a"
import script from "./ConcessionaryDetails.vue?vue&type=script&lang=js"
export * from "./ConcessionaryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports